export default __webpack_public_path__ + "static/media/sofiaProBoldAz.48c71aa3.otf";